import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { relativePath, ROUTES } from '@futrli/shared-services';

import { WorkspacesContainer } from '../containers/workspaces-container';

export const WorkspacesManagementRouter = () => {
  return (
    <Routes>
      <Route path={relativePath(ROUTES.WORKSPACE_BY_ID_ROUTE, '/*')} element={<WorkspacesContainer />} />
    </Routes>
  );
};
